var _defs, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _circle, _circle2, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvanceAndWithholdingTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8",
    x1: 233.83,
    y1: 191.4,
    x2: 248.89,
    y2: 191.4,
    gradientTransform: "rotate(42.13 298.972 35.007)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_1_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8",
    "data-name": "SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8",
    x1: 76.15,
    y1: -210,
    x2: 118.41,
    y2: -210,
    gradientTransform: "translate(0 237.97)",
    xlinkHref: "#SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVG_ID_2_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8",
    "data-name": "SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8",
    x1: 93.87,
    y1: 118.71,
    x2: 153.18,
    y2: 118.71,
    xlinkHref: "#SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98 131.85H62.7c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.12M116.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64V92.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVG_ID_1_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8)",
    d: "M113.25 33.61l4.06-11.27H77.25l4.06 11.27h31.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M108.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M71.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 115.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 98.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 79.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M86.16 75.36C86.73 69.32 91.82 64.6 98 64.6s11.22 4.68 11.83 10.67"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 115.61,
    cy: 110.34,
    r: 4.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.73,
    cy: 127.34,
    r: 4.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M112.54 131.19l21.47-24.96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVG_ID_0_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8)",
    d: "M160.21 111.9l-8.43 9.31-9.32-8.42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M146.6 135.29c-5.16 7.16-13.57 11.83-23.07 11.83-15.69 0-28.41-12.72-28.41-28.41s12.72-28.41 28.41-28.41 28.41 12.72 28.41 28.41",
    stroke: "url(#SVG_ID_2_de291cbb00c08e383e874b21e9353b8a7a085beb0f9e4f391b16e92c9baa47e8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceAndWithholdingTax);
export default __webpack_public_path__ + "static/media/advanceAndWithholdingTax.31aff2671e8986482412520ebcd96f30.svg";
export { ForwardRef as ReactComponent };